import * as Utils from './utils'


/**
 * Replace __TITLE__ in <title> tag under <head>
 * @param {String} title 
 */
export const replaceHtmlTitle = (title, message) => {
    const placeholder = /__TITLE__/g;
    document.title = document.title.replace(placeholder, title.toUpperCase())
        + " "
        + message;
}



/**
 * Append extra text below "Purchse" message
 * @param {String} message 
 */
export const addExtraMessage = message => {
    const dom = document.querySelector('.message-extra');
    dom.innerHTML = message;
}




/**
 * Set Header (hero) image's clickthrough
 * @param {Sting} exitUrl 
 */
export const setHeaderExit = exitUrl => {
    const QUERY_HEADER = '#exit-header';
    const header = document.querySelector(QUERY_HEADER);
    header.href = exitUrl;
}





/**
 * Set "Purchase Now" button's clickthrough
 * @param {Sting} exitUrl 
 */
export const setPurchaseNowExit = exitUrl => {
    const QUERY = '#exit-purchase-now';
    const btn = document.querySelector(QUERY);
    btn.href = exitUrl;
}



export const setHeaderParallax = config => {
    const scene = document.getElementById('parallax');
    let parallaxInstance;
    // Array of layer data. either config.desktop or config.mobile
    let layerDataArray;

    // Div wrapper for img
    let layerWrapper;
    // The layer image
    let layerImage;

    let blurredBg;

    // console.log(Utils.isPhone())

    // Is it for desktop or mobile?
    layerDataArray = Utils.isPhone() ? config.mobile : config.desktop;

    if (layerDataArray) {
        layerDataArray.forEach(layerData => {
            layerWrapper = document.createElement('div');
            layerWrapper.classList.add('layer');
            layerWrapper.setAttribute('data-depth', layerData.depth);

            layerImage = document.createElement('img');
            layerImage.src = `img/${layerData.file}`;
            layerImage.style.transform = `scale(${layerData.scale})`;

            // Experimental blurred background behind parallax
            if(!blurredBg){
                blurredBg = document.createElement('img');
                blurredBg.src = `img/${layerData.file}`;
                blurredBg.classList.add('header-bg-blurred');
                document.querySelector('.hero-container').appendChild(blurredBg);
            }

            layerWrapper.appendChild(layerImage);

            scene.appendChild(layerWrapper);
        });
        // Activate parallax
        parallaxInstance = new Parallax(scene);
    }

}